<template>
  <router-view />
</template>

<script>
export default {
  name: "CustomerMain",
};
</script>

<style></style>
